import React, { useCallback, useState } from 'react';
import { Button, Select, Input, notification } from 'antd';
import './ShipmentAddTrackSimple.scss';
import { getIcon } from '../../../utils/images';
import { useFetch } from '../../../utils/hooks';
import { addTrackingShipment, getShippingLines } from '../../../services/shipments';
import { Form, Radio } from 'antd';
import { validate_booking_bl } from '../../../utils/validation';
import { match_shipping_line_prefix } from '../../../utils/prefix';

const ShipmentAddTrackSimple = ({ refetch, close, mixpanel, onTabChange }) => {
  const [form] = Form.useForm();
  const [isBlSelected, setIsBlSelected] = useState(false);
  const [shippingLineSelected, setShippingLineSelected] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const { data } = useFetch(useCallback(getShippingLines, []));
  const shippingLines = data?.lines?.map(line => ({ value: line[1], label: line[1] }));

  const handleTrackSelectorChange = (e) => {
    setIsBlSelected(e.target.value === 'bl');
  };

  const handleShippingLineSelected = (value) => {
    setShippingLineSelected(value);
  };

  const handleShippingLinePrefix = (event) => {
    const matchedLine = match_shipping_line_prefix(event.target.value);
    if (matchedLine) {
      handleShippingLineSelected(matchedLine[0]);
      setIsBlSelected(matchedLine[1] === 'bl');
      form.setFieldsValue({ selector: matchedLine[1], shipping_line: matchedLine[0] });
    }
  };

  async function handleFinish(values) {
    const params = { ...values };
    params['number'] = params.number.toUpperCase();

    try {
      await validate_booking_bl(params['number'], shippingLineSelected, isBlSelected);
      await addTrackingShipment(params);
      refetch();
      close();
      form.resetFields();
    } catch (e) {
      api['error']({
        message: e?.response?.data?.message || e?.message,
        description: e?.response?.data?.description || e?.description,
        placement: 'top',
      });

      e.errType === 'VALIDATION' && process.env.REACT_APP_ENV === 'production' && mixpanel.track('Invalid tracking', {
        'value': params['number'],
        'sl': shippingLineSelected,
        'selector': isBlSelected ? 'bl' : 'booking',
      });
    }
  }

  return (
    <div className="ShipmentAddTrackSimple">
      <div className="header">
        <div className="header__title">Add Shipment</div>
        <div
          className="header__subtitle">{'Enter your booking number, Master BL or container number \n to start tracking your shipment'}</div>
      </div>

      {contextHolder}
      <Form
        name="track"
        onFinish={handleFinish}
        autoComplete="off"
        form={form}
        initialValues={{ selector: isBlSelected ? 'bl' : 'booking', shipping_line: shippingLineSelected }}
        layout="vertical"
        className="form"
      >
        <Form.Item
          className="form__item"
          label={
            <div className="form__label">
              <span><img src={getIcon('lens')} /></span><span>Shipment Details</span>
            </div>
          }
          rules={[
            { required: true, message: 'Field is required!' },
          ]}
          name="number"
        >
          <Input
            className="rounded"
            placeholder={isBlSelected ? 'Container Number' : 'Booking number or BL'}
            onInput={handleShippingLinePrefix}
          />
        </Form.Item>

        <Form.Item
          className="form__item"
          label=""
          name="selector"
        >
          <Radio.Group value={'booking'} onChange={handleTrackSelectorChange}>
            <Radio value={'booking'}>Booking Number / Master BL</Radio>
            <Radio value={'bl'}>Container Number</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          className="form__item"
          label={
            <div className="form__label">
              <span><img src={getIcon('ship')} /></span><span>Shipping Line</span>
            </div>
          }
          rules={[{ required: true, message: 'Please select one of the shipping lines' }]}
          name="shipping_line"
        >
          <Select
            showSearch
            value={shippingLineSelected}
            placeholder="Select Shipping Line"
            onChange={handleShippingLineSelected}
            options={shippingLines}
          />
        </Form.Item>

        <Form.Item
          className="form__item"
          label={
            <div className="form__label">
              <span><img src={getIcon('eye-gray')} /></span><span>Shipment Reference</span>
            </div>
          }
          name="client_ref"
        >
          <Input
            className="rounded"
            placeholder="(Optional) Reference for your shipment"
          />
        </Form.Item>


        <Form.Item className="form__item">
          <Button type="primary" htmlType="submit" className="bold-btn">
            Track Shipment
          </Button>
        </Form.Item>
      </Form>
      <div className="nowlun-link">
        <Button
          variant="link"
          onClick={() => onTabChange('nowlun')}
          className="nowlun-button"
        >
          Add shipment details manually
        </Button>
      </div>
    </div>
  );
};

export default ShipmentAddTrackSimple;
